module.exports = __webpack_public_path__ + "static/media/ellipsis.fd1749d0.svg";